import yinYangAnimation from './YinYang_Alpha 3.gif';
import nodeRocksTraits from './NodeRocks_Traits3.gif';

export const images = {
  nodeRocks: {
    yinYang: yinYangAnimation,
    traits: nodeRocksTraits
  }
} as const;